import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
import React from 'react';
import Img from 'gatsby-image';
import { MDXProvider as Provider } from '@mdx-js/react';
import Heading from '../components/text/Heading/Heading';
import Spacer from '../components/structure/Spacer/Spacer';
import Link from '../components/elements/Link/Link';
import Wrapper from '../components/structure/Wrapper/Wrapper';
import CTASection from '../components/modules/CTASection/CTASection';
import HeaderImage from '../components/media/HeaderImage/HeaderImage';
import HeaderImg from '../components/media/HeaderImg/HeaderImg';
import Separator from '../components/structure/Separator/Separator';
import { jsx as ___EmotionJSX } from "@emotion/react";
const components = {
  h1: Heading,
  hr: Spacer,
  a: Link
};
const shortcodes = {
  Wrapper,
  CTASection,
  Link,
  HeaderImage,
  HeaderImg,
  Heading,
  Img,
  Separator
};
const MDXProvider = _ref => {
  let {
    children
  } = _ref;
  return ___EmotionJSX(Provider, {
    components: _objectSpread(_objectSpread({}, components), shortcodes)
  }, children);
};
export default MDXProvider;